import {
    MetricCard,
    MetricContainer,
    MetricContent,
    MetricIconWrapper,
    MetricSkeletonCircle,
    MetricSkeletonLabel,
    MetricSkeletonLabelContainer,
    MetricSkeletonSubLabel,
    MetricSkeletonValue,
} from 'shared/issue_metrics/styled';

export type LoadingStateProps = Readonly<{
    metricCount?: number;
}>;

function LoadingMetricCard() {
    return (
        <MetricCard role="presentation" aria-hidden="true">
            <MetricIconWrapper>
                <MetricSkeletonCircle />
            </MetricIconWrapper>
            <MetricContent>
                <MetricSkeletonValue />
                <MetricSkeletonLabelContainer>
                    <MetricSkeletonLabel />
                    <MetricSkeletonSubLabel />
                </MetricSkeletonLabelContainer>
            </MetricContent>
        </MetricCard>
    );
}

export function LoadingState({ metricCount = 5 }: LoadingStateProps) {
    return (
        <MetricContainer role="alert" aria-busy="true" aria-label="Loading metrics">
            {[...Array(metricCount)].map((_, index) => (
                <LoadingMetricCard key={index} />
            ))}
        </MetricContainer>
    );
}
